/**
 * @desc：有些行整行不可编辑，添加了标示tabindex = -1,一直循环找到可编辑的行数
 * @param tr {node} 当前行不可编辑的行
 * @param needJumpTimes {number} 向上/下查找的行数
 * @param direction {string}  'down'/ 'up' 向上或向下查找
 * @return 返回需要向上/下查找的行数
 */
export default function calculateNeedJumpTimes(tr, needJumpTimes, direction) {
    let tempTr = tr;
    let tempNeedJumpTimes = needJumpTimes;
    while (tempTr !== null && tempTr.getAttribute('tabindex') === '-1') {
        tempNeedJumpTimes += 1;
        tempTr = direction === 'up' ? tempTr.previousElementSibling : tempTr.nextElementSibling;
    }
    return tempNeedJumpTimes;
}
